export default "__VITE_ASSET__Ja5wsHGf__"